export type DomainKey = 'projects' | 'customers' | 'orders';
export type ProjectResourceKey =
  | 'types' | 'categories' | 'currencies' | 'allocation-types'
  | 'client-type-categories' | 'client-type-models' | 'client-types'
  | 'scopes' | 'usages' | 'cost-center-regions';
export type ResourceKey = ProjectResourceKey;
export interface LookupConfigEntry {
  fields: string;
  sort?: string;
  filterKey: string;
}
export const LOOKUP_REGISTRY: Record<DomainKey, {
  basePath: string;
  resources: Partial<Record<ResourceKey, LookupConfigEntry>>;
}> = {
  projects: {
    basePath: '/api/projects',
    resources: {
      types: { fields: 'number,localizedName', sort: 'localizedName', filterKey: 'fullText' },
      categories: { fields: 'number,localizedName', sort: 'localizedName', filterKey: 'fullText' },
      currencies: { fields: 'iso,localizedName,symbol', sort: 'localizedName', filterKey: 'fullText' },
      'allocation-types': { fields: 'number,localizedName', filterKey: 'fullText' },
      'client-type-categories': { fields: 'number,localizedName', filterKey: 'fullText' },
      'client-type-models': { fields: 'number,localizedName', filterKey: 'fullText' },
      'client-types': { fields: 'number,localizedName', filterKey: 'fullText' },
      scopes: { fields: 'number,localizedName', filterKey: 'fullText' },
      usages: { fields: 'number,localizedName', filterKey: 'fullText' },
      'cost-center-regions': { fields: 'number,localizedName', filterKey: 'fullText' }
    }
  },
  customers: { basePath: '/api/customers', resources: {} },
  orders: { basePath: '/api/orders', resources: {} }
};
